export const SET_LOCATION = 'SET_LOCATION'

export function setLocation(location) {
  return {
    type: SET_LOCATION,
    payload: location
  }
}
